/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Youtube_Export_File_Too_LargeInputs */

const cs_youtube_export_file_too_large = /** @type {(inputs: Youtube_Export_File_Too_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video smí mít nejvýše 2 GB.`)
};

const en_youtube_export_file_too_large = /** @type {(inputs: Youtube_Export_File_Too_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video must be 2 GB or smaller.`)
};

/**
* | output |
* | --- |
* | "Video must be 2 GB or smaller." |
*
* @param {Youtube_Export_File_Too_LargeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const youtube_export_file_too_large = /** @type {((inputs?: Youtube_Export_File_Too_LargeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Youtube_Export_File_Too_LargeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_youtube_export_file_too_large(inputs)
	return cs_youtube_export_file_too_large(inputs)
});